import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default () => {
	const capsuleImages = document.querySelectorAll('.js-capsule-image-animation');

	if (!capsuleImages.length) return;

	capsuleImages.forEach(container => {

		const image = container.querySelector('.js-capsule-image-animation-image');
		const blob = container.querySelector('.js-capsule-image-animation-blob');

		gsap.set(image, { opacity: 0 });
		gsap.set(blob, { scale: 1.2 });

		gsap.to(blob, {
			duration: 0.4,
			opacity: 1,
			scale: 1,
			ease: 'power4.out',
			scrollTrigger: {
				trigger: blob,
				start: "top 80%",
			},
		})

		gsap.to(blob, {
			duration: 0.25,
			width: '100%',
			borderRadius: 0,
			ease: 'power4.in',
			scrollTrigger: {
				trigger: blob,
				start: "top 70%",
			},
		}).then(() => {
			gsap.to(image, {
				delay: 0.1,
				duration: 0.15,
				opacity: 1,
				ease: 'power1.inOut',
			});
		});
	});
}